import { connect } from 'react-redux';
import { fetchConfirmWithdraw as _fetchConfirmWithdraw } from '../../redux/actions/confirmWithdrawActions';
import { getQueryParam } from '../../helpers/queryParamsHelper';
import ConfirmWithdrawComponent from './ConfirmWithdrawComponent';
var mapStateToProps = function mapStateToProps(state) {
  var processingConfirmWithdraw = state.apiProcessing.processingConfirmWithdraw,
    _state$confirmWithdra = state.confirmWithdraw,
    message = _state$confirmWithdra.message,
    error = _state$confirmWithdra.error;
  return {
    processingConfirmWithdraw: processingConfirmWithdraw,
    message: message,
    error: error
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  var d1 = getQueryParam('d1');
  var userid = getQueryParam('UserId');
  var verifycode = getQueryParam('verifycode');
  return {
    fetchConfirmWithdraw: function fetchConfirmWithdraw() {
      return dispatch(_fetchConfirmWithdraw({
        verifycode: verifycode,
        userid: userid,
        d1: d1
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmWithdrawComponent);